import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { ConfirmDialogInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Gruppe } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppenService } from '../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    DateTableColumn,
    KieneBooleanTableColumn,
    NumberTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor, ToolbarButton } from '../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import {
    HitSyncEinstellungenDialogComponent,
    HitSyncEinstellungenInput,
    HitSyncEinstellungenResult,
} from '../../dialogs/hit-sync-einstellungen-dialog/hit-sync-einstellungen-dialog.component';

@Component({
    selector: 'kiene-historie-gruppen',
    templateUrl: './historie-gruppen.component.html',
    styleUrls: ['./historie-gruppen.component.scss'],
})
export class HistorieGruppenComponent implements OnInit, OnDestroy {
    tableDescriptor = new TableDescriptor();
    watchClientSubscription: Subscription;
    kundeColumn: TableColumn;
    kundeZusatzColumn: TableColumn;
    einstalldatumBisCol: DateTableColumn;
    herdenCol: TableColumn;
    anzahlToteCol: TableColumn;
    hitSyncCol: TableColumn;
    abgangsdatumVonCol: DateTableColumn;
    abgangsdatumBisCol: DateTableColumn;
    schlachtK12Col: NumberTableColumn;
    schlachtG12Col: NumberTableColumn;
    zunahmenK12Col: NumberTableColumn;
    zunahmenG12Col: NumberTableColumn;
    erloesCol: NumberTableColumn;
    verkaeufeCol: NumberTableColumn;
    mastdauerCol: NumberTableColumn;
    futterCol: NumberTableColumn;
    tageszunahmenCol: NumberTableColumn;

    constructor(
        private localStorageService: LocalStorageService,
        private tableService: KieneTableService,
        private dialog: MatDialog,
        private gruppenService: GruppenService,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private router: Router,
    ) {}

    ngOnDestroy(): void {
        this.watchClientSubscription.unsubscribe();
        this.tableService = null;
    }

    ngOnInit(): void {
        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe((response: Client) => {
            this.spaltenEinAusblenden(response);
        });

        this.tableDescriptor.headline = 'Historie Tiergruppen';
        this.tableDescriptor.uniqueIdentifier = 'Historie Gruppen';
        this.tableDescriptor.alternativeApiUrl = this.apiBaseUrl + 'gruppe/read_hist_kundenportal.php';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.initialSortColumn = 'einstalldatum_von';
        this.tableDescriptor.nameOfIdField = 'gruppe_id';
        this.tableDescriptor.route = '/gruppen/historie/';
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.showDetailsVoid = this.goToDetails.bind(this);
        this.tableDescriptor.showDownloads = false;
        this.tableDescriptor.sendCurrentClient = true;

        this.tableDescriptor.columns = this.getColumns();
        this.spaltenEinAusblenden(this.localStorageService.getCurrentClient());

        this.tableDescriptor.options = this.getOptions();
        this.tableDescriptor.toolbarButtons = this.getToolbarButtons();

        this.tableDescriptor.totalRow = true;
        this.tableDescriptor.totalRowApiUrl = this.apiBaseUrl + 'gruppe/read_hist_kundenportal_summen.php';
    }

    spaltenEinAusblenden(client: Client) {
        if (client) {
            const rinder: boolean = !!(client.rind > 0);
            if (this.kundeColumn) this.kundeColumn.isActive = false;
            if (this.kundeZusatzColumn) this.kundeZusatzColumn.isActive = false;
            if (this.einstalldatumBisCol) this.einstalldatumBisCol.isActive = rinder;
            if (this.herdenCol) this.herdenCol.isActive = rinder;
            if (this.anzahlToteCol) this.anzahlToteCol.isActive = rinder;
            if (this.hitSyncCol) this.hitSyncCol.isActive = rinder;
            if (this.abgangsdatumVonCol) this.abgangsdatumVonCol.isActive = !rinder;
            if (this.abgangsdatumBisCol) this.abgangsdatumBisCol.isActive = rinder;
            if (this.schlachtK12Col) this.schlachtK12Col.isActive = rinder;
            if (this.schlachtG12Col) this.schlachtG12Col.isActive = rinder;
            if (this.zunahmenK12Col) this.zunahmenK12Col.isActive = rinder;
            if (this.zunahmenG12Col) this.zunahmenG12Col.isActive = rinder;
            if (this.erloesCol) this.erloesCol.isActive = rinder;
            if (this.verkaeufeCol) this.verkaeufeCol.isActive = !rinder;
            if (this.mastdauerCol) this.mastdauerCol.isActive = !rinder;
            if (this.futterCol) this.futterCol.isActive = !rinder;
            if (this.tageszunahmenCol) this.tageszunahmenCol.isActive = !rinder;
        } else {
            // alles einblenden
            if (this.kundeColumn) this.kundeColumn.isActive = true;
            if (this.kundeZusatzColumn) this.kundeZusatzColumn.isActive = true;
            if (this.einstalldatumBisCol) this.einstalldatumBisCol.isActive = true;
            if (this.herdenCol) this.herdenCol.isActive = true;
            if (this.anzahlToteCol) this.anzahlToteCol.isActive = true;
            if (this.hitSyncCol) this.hitSyncCol.isActive = true;
            if (this.abgangsdatumVonCol) this.abgangsdatumVonCol.isActive = true;
            if (this.abgangsdatumBisCol) this.abgangsdatumBisCol.isActive = true;
            if (this.schlachtK12Col) this.schlachtK12Col.isActive = true;
            if (this.schlachtG12Col) this.schlachtG12Col.isActive = true;
            if (this.zunahmenK12Col) this.zunahmenK12Col.isActive = true;
            if (this.zunahmenG12Col) this.zunahmenG12Col.isActive = true;
            if (this.erloesCol) this.erloesCol.isActive = true;
            if (this.verkaeufeCol) this.verkaeufeCol.isActive = true;
            if (this.mastdauerCol) this.mastdauerCol.isActive = true;
            if (this.futterCol) this.futterCol.isActive = true;
            if (this.tageszunahmenCol) this.tageszunahmenCol.isActive = true;
        }
        this.tableService.updateColumns();
    }

    getColumns(): TableColumn[] {
        const columns = [];
        this.kundeColumn = new TableColumn('kunde', 'Kunde');
        columns.push(this.kundeColumn);
        this.kundeZusatzColumn = new TableColumn('zusatz', 'Kunde Zusatz');
        columns.push(this.kundeZusatzColumn);

        columns.push(new TableColumn('bezeichnung', 'Gruppenname'));
        columns.push(new TableColumn('produktionsabschnitt', 'Abschnitt'));
        this.herdenCol = new TableColumn('herdenname', 'Herdenname');
        columns.push(this.herdenCol);

        columns.push(new TableColumn('anzahl_tiere_gesamt', 'Eingestallte Tiere'));
        columns.push(new TableColumn('stall', 'Standort'));

        columns.push(new DateTableColumn('einstalldatum_von', 'Einstalldatum von', 'dd.MM.yy'));
        this.einstalldatumBisCol = new DateTableColumn('einstalldatum_bis', 'Einstalldatum bis', 'dd.MM.yy');
        columns.push(this.einstalldatumBisCol);

        this.abgangsdatumVonCol = new DateTableColumn('abgangsdatum_von', 'Abgangsdatum von', 'dd.MM.yy');
        columns.push(this.abgangsdatumVonCol);

        this.abgangsdatumBisCol = new DateTableColumn('abgangsdatum_bis', 'Abgangsdatum bis', 'dd.MM.yy');
        columns.push(this.abgangsdatumBisCol);

        columns.push(new NumberTableColumn('verluste', 'Verluste', '1.1-1', '%'));
        this.anzahlToteCol = new TableColumn('anzahl_tote', 'Tote');
        columns.push(this.anzahlToteCol);
        if (this.localStorageService.hasPermission(9161)) {
            this.schlachtK12Col = new NumberTableColumn(
                'schlachtgewicht_avg_unter12.wert',
                'Schlachtgew. <12M',
                '1.2-2',
                'kg',
            );
            this.schlachtK12Col.isSortable = false;
            columns.push(this.schlachtK12Col);

            this.schlachtG12Col = new NumberTableColumn(
                'schlachtgewicht_avg_ueber12.wert',
                'Schlachtgew. >12M',
                '1.2-2',
                'kg',
            );
            this.schlachtG12Col.isSortable = false;
            columns.push(this.schlachtG12Col);

            this.zunahmenK12Col = new NumberTableColumn(
                'nettozunahmen_avg_unter12.wert',
                'Nettozunahmen <12M',
                '1.2-2',
                'kg',
            );
            this.zunahmenK12Col.isSortable = false;
            columns.push(this.zunahmenK12Col);

            this.zunahmenG12Col = new NumberTableColumn(
                'nettozunahmen_avg_ueber12.wert',
                'Nettozunahmen >12M',
                '1.2-2',
                'kg',
            );
            this.zunahmenG12Col.isSortable = false;
            columns.push(this.zunahmenG12Col);
        }
        if (this.localStorageService.hasPermission(9162)) {
            this.erloesCol = new NumberTableColumn('erloesdifferenz_avg.wert', ' Erlösdifferenz', '1.2-2', '€');
            this.erloesCol.isSortable = false;
            columns.push(this.erloesCol);
        }

        this.verkaeufeCol = new NumberTableColumn('anzahl_abgaenge', 'Verkäufe', '1.0-0');
        columns.push(this.verkaeufeCol);

        this.mastdauerCol = new NumberTableColumn('mastdauer', 'Mastdauer', '1.0-0', 'd');
        columns.push(this.mastdauerCol);

        this.futterCol = new NumberTableColumn('futterverwertung', 'Futterverwertung', '1.1-1', 'kg');
        columns.push(this.futterCol);

        this.tageszunahmenCol = new NumberTableColumn('tageszunahmen', 'Tageszunahmen', '1.1-1', 'kg');
        columns.push(this.tageszunahmenCol);

        this.hitSyncCol = new DateTableColumn('synchronisiert', 'HIT Sync.', 'dd.MM.yy HH:mm', {
            alternativeField: 'hit_fehler',
        });

        columns.push(
            new DateTableColumn('synchronisiert', 'HIT Sync.', 'dd.MM.yy HH:mm', { alternativeField: 'hit_fehler' }),
        );
        columns.push(new KieneBooleanTableColumn('hit_sync_aktiv', 'HIT Sync aktiv'));
        return columns;
    }

    getOptions() {
        const options: TableOption[] = [];
        options.push(new TableOption(this.ausHistorieHolen.bind(this), 'Aus Historie holen', 'undo', 9114));
        options.push(
            new TableOption(this.openHitSyncEinstellungen.bind(this), 'HIT Sync Einstellung', 'settings', 9195, {
                conditions: [new Condition('bezeichnung', Operator.UNGLEICH, 'Standard')],
            }),
        );
        options.push(new TableOption(this.goToDetails.bind(this), 'Detailsseite öffnen', 'description', 9111));
        return options;
    }

    getToolbarButtons(): ToolbarButton[] {
        const buttons: ToolbarButton[] = [];
        return buttons;
    }

    goToDetails(gruppe: Gruppe) {
        if (gruppe.rind > 0) {
            this.router.navigate(['/gruppen', 'historie', gruppe.gruppe_id]).then();
        } else {
            this.router.navigate(['/gruppen', 'historie', 'schwein', gruppe.gruppe_id]).then();
        }
    }

    ausHistorieHolen(gruppe: Gruppe) {
        const input = new ConfirmDialogInput();
        input.headline = 'Gruppe aus Historie holen?';
        input.text = 'Gruppe aus Historie holen und wieder in "aktuelle Gruppen" anzeigen?';
        input.okButton = 'Verschieben';

        this.dialog
            .open(ConfirmDialogComponent, { width: '500px', data: input })
            .afterClosed()
            .subscribe(response => {
                if (response) {
                    this.gruppenService.historieAendern(gruppe, false).subscribe({
                        next: () => {
                            this.messageService.infoMessage('Gruppe erfolgreich verschoben!');
                            this.tableService?.reload();
                        },
                        error: err => {
                            this.messageService.errorMessage('Gruppe konnte nicht verschoben werden!', err);
                        },
                    });
                }
            });
    }

    openHitSyncEinstellungen(gruppe: Gruppe) {
        const input = new HitSyncEinstellungenInput();
        input.gruppe = gruppe;
        this.dialog
            .open(HitSyncEinstellungenDialogComponent, { data: input })
            .afterClosed()
            .subscribe((result: HitSyncEinstellungenResult) => {
                if (result?.confirmed && result.gruppe) {
                    gruppe.hit_sync_aktiv = Number(result.gruppe.hit_sync_aktiv);
                    this.tableService?.reload('openHitSyncEinstellungen');
                }
            });
    }
}
